const get = () =>
  Promise.resolve([
    "Actividad física y del Deporte",
        "Administración de empresas",
        "Administración de Recursos Humanos",
        "Agronomía",
        "Arquitectura",
        "Arte",
        "Astronomía",
        "Biología",
        "Biología Química",
        "Biotecnología",
        "Ciencia Política y Gobierno",
        "Ciencias Ambientales",
        "Ciencia y Tecnología de los Alimentos",
        "Comercio Internacional",
        "Comunicación Social",
        "Contaduría Pública y Auditoría",
        "Derecho",
        "Diseño de Interiores",
        "Diseño de Modas",
        "Diseño Gráfico",
        "Diseño Industrial",
        "Economía",
        "Enfermería",
        "Estadística",
        "Filología",
        "Filosofía",
        "Finanzas",
        "Física",
        "Geografía",
        "Geología",
        "Historia",
        "Historia del Arte",
        "Ingeniería Administrativa",
        "Ingeniería Catastral y Geodesia",
        "Ingeniería Civil",
        "Ingeniería de Desarrollo de Producto",
        "Ingeniería de Procesos",
        "Ingeniería de Producción",
        "Ingeniería Electrónica",
        "Ingeniería Eléctrica",
        "Ingeniería en Agrimensura",
        "Ingeniería en Petróleos",
        "Ingeniería en Sistemas",
        "Ingeniería en Telecomunicaciones",
        "Ingeniería Industrial",
        "Ingeniería Mecatrónica",
        "Ingeniería Mecánica",
        "Ingeniería Multimedia",
        "Licenciatura en Español y Literatura",
        "Licenciatura en Lenguas Extranjeras/Modernas",
        "Liderazgo Organizacional",
        "Lingüística",
        "Literatura",
        "Matemática",
        "Mercadotecnia",
        "Pedagogía",
        "Periodismo",
        "Psicología",
        "Psicopedagogía",
        "Publicidad y Relaciones Públicas",
        "Química",
        "Relaciones Internacionales",
        "Sociología",
        "Tecnología en análisis y desarrollo de sistemas de Información",
        "Tecnología en negocios internacionales",
        "Trabajo Social",
        "Traducción e Interpretación",
        "Turismo",
        "Otra",
  ]);

const degreesService = {
  get,
};

export default degreesService;
